import { render, staticRenderFns } from "./AddWorkShiftModal.vue?vue&type=template&id=1dac7b7b&"
import script from "./AddWorkShiftModal.vue?vue&type=script&lang=js&"
export * from "./AddWorkShiftModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports